<template>
  <div class="new-header">
    <div class="container-fluid">
      <div class="d-menu">
        <div class="row new-header-top">
          <div class="col-1 text-left px-0">
            <template v-if="env === 'prod'">
              <a href="https://app.fexspace.com">
                <img src="@/assets/logo-bbb-small.png" />
              </a>
            </template>
            <template v-if="env !== 'prod'">
              <router-link to="/">
                <img src="@/assets/logo-bbb-small.png" />
              </router-link>
            </template>
          </div>
          <div class="col px-3 pl-4">
            <template v-if="env === 'local'">
              <ul class="url pl-1">
                <li>
                  <a :href="protocol + '//' + host + ':9009'" id="dashboard">Dashboard</a>
                </li>
                <li class="active">
                  <a :href="protocol + '//' + host + ':7080'" id="drive">Drive</a>
                </li>
                <li>
                  <a :href="protocol + '//' + host + ':3002/collaboration'" id="projects">Projects</a>
                </li>
                <li>
                  <a :href="protocol + '//' + host + ':3002/tasks'" id="task">
                    Tasks
                  </a>
                </li>
                <template v-if="$store.getters.HAS_CRM">
                  <li>
                    <a :href="protocol + '//' + host + ':3002/crm'">
                      CRM
                    </a>
                  </li>
                </template>
                <!--<li v-if="$store.getters.USER_PLAN != 1">
                    <a :href="protocol+'//'+host+':9009/contacts'">Contacts</a>
                  </li>-->
                <li>
                  <a :href="protocol + '//' + host + ':9009/calendar/month'" id="schedules">Schedules</a>
                </li>
                <li>
                  <a :href="protocol + '//' + host + ':9009/m/meetings'" id="meeting">Meetings</a>
                </li>
                <li>
                  <a :href="protocol + '//' + host + ':9009/m/chats'" id="conversations">Conversations</a>
                </li>
                <li>
                  <a :href="protocol + '//' + host + ':3002/teams'" id="team">
                    Teams
                  </a>
                </li>
                <template v-if="$store.getters.ACCT_TYPE == 2">
                  <li>
                    <a :href="protocol + '//' + host + ':9009/explore'" id="feed">Feed</a>
                  </li>
                </template>
                <template v-else>
                  <li>
                    <a :href="protocol + '//' + host + ':9009/explore'" id="feed">Community</a>
                  </li>
                </template>
              </ul>
            </template>
            <template v-else-if="env === 'prod'">
              <ul class="url pl-1">
                <li>
                  <a :href="DASHBOARD" id="dashboard">Dashboard</a>
                </li>
                <li class="active">
                  <a :href="DRIVE" id="drive">Drive</a>
                </li>
                <li>
                  <a :href="PROJECTS" id="projects">Projects</a>
                </li>
                <li>
                  <a :href="TASKS" id="task">Tasks</a>
                </li>
                <li>
                  <a :href="CRM" id="task">CRM</a>
                </li>
                <li>
                  <a :href="CALENDAR" id="schedules">Schedules</a>
                </li>
                <li>
                  <a :href="MEETING" id="meeting">Meetings</a>
                </li>
                <li>
                  <a :href="MESSAGE" id="conversations">Conversations</a>
                </li>
                <li>
                  <a :href="TEAMS" id="team">Teams</a>
                </li>
                <template v-if="$store.getters.ACCT_TYPE == 2">
                  <li>
                    <a :href="EXPLORE" id="feed">Feed</a>
                  </li>
                </template>
                <template v-else>
                  <li>
                    <a :href="EXPLORE" id="feed">Community</a>
                  </li>
                </template>
              </ul>
            </template>
          </div>
          <div class="col-3 text-right px-0">
            <span class="px-2 bell custom-tooltip-container" @click="show_notification">
              <notification-icon /><span class="notificattion-count" v-if="$store.getters.TOTAL_NOTIFICATION">{{
                $store.getters.TOTAL_NOTIFICATION }}</span>
              <span class="custom-tooltiptext" style="left: -22px; top: 30px">
                Notification
              </span>
            </span>
            <span class="px-2 chat custom-tooltip-container" @click="show_chat">
              <chat-icon /><span class="notificattion-count" v-if="$store.getters.TOTAL_CHAT">{{ $store.getters.TOTAL_CHAT
              }}</span>
              <span class="custom-tooltiptext" style="left: -20px; top: 30px">
                Messenger
              </span>
            </span>
            <span class="px-2 note custom-tooltip-container" @click="show_note">
              <note-icon />
              <span class="custom-tooltiptext" style="left: -8px; top: 30px">
                Note
              </span>
            </span>
            <span class="px-2 note custom-tooltip-container" @click="invite">
              <invite-icon />
              <span class="custom-tooltiptext" style="left: -8px; top: 30px">
                Invite
              </span>
            </span>
            <template v-if="$store.getters.HAS_INVEX">
              <span v-click-outside="hideInvexDropDownMenu">
                <span class="px-2 note custom-tooltip-container" @click="showinvexdropdown">
                  <menu-icon />
                  <span class="custom-tooltiptext" style="left: -8px; top: 30px">
                    Invex ERP
                  </span>
                  <div class="userdropdown erp-menu" v-if="invexdropdown">
                    <h4>ERP Tools</h4>
                    <ul>
                      <template v-if="$store.getters.ISADMIN">
                        <li v-for="(role, index) in roles" :key="index">
                          <h5>{{ role.name }}</h5>
                          <div class="menu-grid">
                            <a v-for="(r, i) in role.roles" :href="$store.getters.INVEX_DOMAIN + '/auth?invextoken=' + invextoken + '&redirect=' +
                              $store.getters.INVEX_DOMAIN + r.link + '&route=' + $store.getters.INVEX_API_URL"
                              target="_blank" :key="i">
                              <span>
                                <InvexMoneyTick />
                              </span>
                              <span>
                                {{ r.name }}
                              </span>
                            </a>
                          </div>
                        </li>
                      </template>
                      <template v-else>
                        <p>Hello</p>
                      </template>
                    </ul>
                  </div>
                </span>
              </span>
            </template>
            <span class="pl-3" v-click-outside="hideMenu">
              <span class="profile-pic" @click="user_dropdown">
                <span class="default-pic" v-if="!$store.getters.PHOTO">{{
                  getName($store.getters.FIRSTNAME)
                }}</span>
                <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
              </span>
              <ul class="userdropdown" v-if="userdropdown">
                <li class="pic-house text-center flex-column">
                  <template v-if="!$store.getters.PHOTO">
                    <span class="default-pic">{{
                      getName($store.getters.FIRSTNAME)
                    }}</span>
                  </template>
                  <template v-if="$store.getters.PHOTO">
                    <span class="trigger_pic_self">
                      <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
                    </span>
                  </template>
                  <span class="name-of-user">{{
                    $store.getters.FIRSTNAME + " " + $store.getters.LASTNAME
                  }}</span>
                  <span class="email-of-user" v-if="$store.getters.EMAIL">{{
                    $store.getters.EMAIL
                  }}</span>
                  <router-link class="update-user-profile" to="/update-profile">Update Profile</router-link>
                </li>
                <li class="download-btn">
                  <span @click="download" style="cursor: pointer">
                    <img src="@/assets/download-btn.svg" width="19px" height="19px" />&nbsp;
                    <span style="color: #3f96d1">Download File Syncing App</span>
                  </span>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/create-page">
                    <img src="@/assets/Plus1.svg" />&nbsp;&nbsp;
                    <span>Create Page</span>
                  </router-link>
                </li>
                <li class="collapsable" @click="show_subdown2" v-if="$store.getters.ISADMIN">
                  <p>
                    <span>
                      <img src="@/assets/page.svg" />&nbsp;&nbsp;
                      <span>Pages</span>
                    </span>
                    <i>
                      <img src="@/assets/angle down.svg" v-if="!sub_dropdown2" />
                      <img src="@/assets/angle up.svg" v-if="sub_dropdown2" />
                    </i>
                  </p>
                  <ul v-if="sub_dropdown2 && page">
                    <li>
                      <router-link :to="{ path: '/page/' + page_url }">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        {{ page }}
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li class="collapsable" @click="show_subdown">
                  <p>
                    <span>
                      <img src="@/assets/Setting.svg" />&nbsp;&nbsp;
                      <span>Settings</span>
                    </span>
                    <i>
                      <img src="@/assets/angle down.svg" v-if="!sub_dropdown" />
                      <img src="@/assets/angle up.svg" v-if="sub_dropdown" />
                    </i>
                  </p>
                  <ul v-if="sub_dropdown">
                    <li>
                      <router-link to="/">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>My Drive</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/create-public-folder">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Create Public Folder</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/create-department">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>All Department</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/group-folder-request">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Group Folder Request</span>
                      </router-link>
                    </li>
                    <!--<li v-if="$store.getters.ISADMIN"><router-link to="folder-access-control">Folder Access Control</router-link></li>-->
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/all-users">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>All Users</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/payments-billing">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Payments & Billing</span>
                      </router-link>
                    </li>
                    <template v-if="$store.getters.ACCT_TYPE == 1">
                      <li>
                        <router-link to="/payments-billing">
                          <i>
                            <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                              <path fill="#666"
                                d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                            </svg>
                          </i>
                          <span>Payments & Billing</span>
                        </router-link>
                      </li>
                    </template>
                    <li v-if="$store.getters.ACCT_TYPE == 2 && !$store.getters.ISADMIN
                      ">
                      <router-link to="/request-more-storage">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Request More Storage</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/usage-quota">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Usage Quota</span>
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li style="cursor: pointer" @click="invite">
                  <span>
                    <img src="@/assets/add account.svg" />&nbsp;&nbsp; Invite
                    People
                  </span>
                </li>
                <li style="cursor: pointer">
                  <a :href="FEEDBACK">
                    <img src="@/assets/Like.svg" />&nbsp;&nbsp;
                    <span> Send a Feedback </span>
                  </a>
                </li>
                <li style="cursor: pointer" @click="copy_invite_link">
                  <span>
                    <img src="@/assets/copy-btn.svg" />&nbsp;&nbsp;
                    <span>Copy Referral Link</span>
                  </span>
                  <input type="hidden" id="referral_link" :value="$store.getters.REFERRAL_LINK" />
                </li>
                <li style="cursor: pointer">
                  <a :href="FAQ">
                    <img src="@/assets/Help.svg" />&nbsp;&nbsp;
                    <span> Help </span>
                  </a>
                </li>
                <li @click="startTour" style="cursor: pointer">
                  <span>
                    <img src="@/assets/puzzle.svg" />&nbsp;&nbsp;
                    <span> Take a Tour </span>
                  </span>
                </li>
                <li style="cursor: pointer" v-if="$store.getters.CURRENT_PLAN == 1">
                  <router-link to="/payments-billing" class="upgrade-btn">
                    Upgrade to Pro
                  </router-link>
                </li>
                <li class="logout text-danger" @click="logout">
                  <span>
                    <img src="@/assets/Signout.svg" />&nbsp;&nbsp;
                    <span class="text-danger">Logout</span>
                  </span>
                </li>
              </ul>
            </span>
          </div>
        </div>
      </div>
      <div class="mobile-menu">
        <div class="row new-header-top">
          <div class="col-4 text-left">
            <template v-if="env === 'prod'">
              <span @click="show_mobile_menu">
                <img src="@/assets/mobile-menu.svg" /> </span>&nbsp;&nbsp;&nbsp;&nbsp;
              <a href="https://app.fexspace.com">
                <img src="@/assets/mobile-logo.svg" />
              </a>
            </template>
            <template v-if="env !== 'prod'">
              <span @click="show_mobile_menu">
                <img src="@/assets/mobile-menu.svg" /> </span>&nbsp;&nbsp;&nbsp;&nbsp;
              <router-link to="/">
                <img src="@/assets/mobile-logo.svg" />
              </router-link>
            </template>
          </div>
          <div class="col-8 text-right">
            <span class="px-2 bell custom-tooltip-container" @click="show_notification">
              <notification-icon /><span class="notificattion-count" v-if="$store.getters.TOTAL_NOTIFICATION">{{
                $store.getters.TOTAL_NOTIFICATION }}</span>
              <span class="custom-tooltiptext" style="left: -22px; top: 30px">
                Notification
              </span>
            </span>
            <span class="px-2 chat custom-tooltip-container" @click="show_chat">
              <chat-icon /><span class="notificattion-count" v-if="$store.getters.TOTAL_CHAT">{{ $store.getters.TOTAL_CHAT
              }}</span>
              <span class="custom-tooltiptext" style="left: -20px; top: 30px">
                Messenger
              </span>
            </span>
            <span class="px-2 note custom-tooltip-container" @click="show_note">
              <note-icon />
              <span class="custom-tooltiptext" style="left: -8px; top: 30px">
                Note
              </span>
            </span>
            <span class="px-2 note custom-tooltip-container" @click="invite">
              <invite-icon />
              <span class="custom-tooltiptext" style="left: -8px; top: 30px">
                Invite
              </span>
            </span>
            <div class="d-inline pl-2 click-out">
              <span class="profile-pic" @click="user_dropdown">
                <span class="default-pic" v-if="!$store.getters.PHOTO">{{
                  getName($store.getters.FIRSTNAME)
                }}</span>
                <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
              </span>
              <ul class="userdropdown" v-show="userdropdown">
                <li class="pic-house text-center flex-column">
                  <template v-if="!$store.getters.PHOTO">
                    <span class="default-pic">{{
                      getName($store.getters.FIRSTNAME)
                    }}</span>
                  </template>
                  <template v-if="$store.getters.PHOTO">
                    <span class="trigger_pic_self">
                      <img :src="$store.getters.PHOTO" v-if="$store.getters.PHOTO" />
                    </span>
                  </template>
                  <span class="name-of-user">{{
                    $store.getters.FIRSTNAME + " " + $store.getters.LASTNAME
                  }}</span>
                  <span class="email-of-user" v-if="$store.getters.EMAIL">{{
                    $store.getters.EMAIL
                  }}</span>
                  <router-link class="update-user-profile" to="/update-profile">Update Profile</router-link>
                </li>
                <li class="download-btn">
                  <span @click="download" style="cursor: pointer">
                    <img src="@/assets/download-btn.svg" width="19px" height="19px" />&nbsp;
                    <span style="color: #3f96d1">Download File Syncing App</span>
                  </span>
                </li>
                <li v-if="$store.getters.ISADMIN">
                  <router-link to="/create-page">
                    <img src="@/assets/Plus1.svg" />&nbsp;&nbsp;
                    <span>Create Page</span>
                  </router-link>
                </li>
                <li class="collapsable" @click="show_subdown2" v-if="$store.getters.ISADMIN">
                  <p>
                    <span>
                      <img src="@/assets/page.svg" />&nbsp;&nbsp;
                      <span>Pages</span>
                    </span>
                    <i>
                      <img src="@/assets/angle down.svg" v-if="!sub_dropdown2" />
                      <img src="@/assets/angle up.svg" v-if="sub_dropdown2" />
                    </i>
                  </p>
                  <ul v-if="sub_dropdown2 && page">
                    <li>
                      <router-link :to="{ path: '/page/' + page_url }">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        {{ page }}
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li class="collapsable" @click="show_subdown">
                  <p>
                    <span>
                      <img src="@/assets/Setting.svg" />&nbsp;&nbsp;
                      <span>Settings</span>
                    </span>
                    <i>
                      <img src="@/assets/angle down.svg" v-if="!sub_dropdown" />
                      <img src="@/assets/angle up.svg" v-if="sub_dropdown" />
                    </i>
                  </p>
                  <ul v-if="sub_dropdown">
                    <li>
                      <router-link to="/">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>My Drive</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/create-public-folder">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Create Public Folder</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/create-department">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>All Department</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/group-folder-request">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Group Folder Request</span>
                      </router-link>
                    </li>
                    <!--<li v-if="$store.getters.ISADMIN"><router-link to="folder-access-control">Folder Access Control</router-link></li>-->
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/all-users">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>All Users</span>
                      </router-link>
                    </li>
                    <li v-if="$store.getters.ISADMIN">
                      <router-link to="/payments-billing">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Payments & Billing</span>
                      </router-link>
                    </li>
                    <template v-if="$store.getters.ACCT_TYPE == 1">
                      <li>
                        <router-link to="/payments-billing">
                          <i>
                            <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                              <path fill="#666"
                                d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                            </svg>
                          </i>
                          <span>Payments & Billing</span>
                        </router-link>
                      </li>
                    </template>
                    <li v-if="$store.getters.ACCT_TYPE == 2 && !$store.getters.ISADMIN
                      ">
                      <router-link to="/request-more-storage">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Request More Storage</span>
                      </router-link>
                    </li>
                    <li>
                      <router-link to="/usage-quota">
                        <i>
                          <svg style="width: 12px; height: 12px" viewBox="0 0 24 24">
                            <path fill="#666"
                              d="M4,11V13H16L10.5,18.5L11.92,19.92L19.84,12L11.92,4.08L10.5,5.5L16,11H4Z" />
                          </svg>
                        </i>
                        <span>Usage Quota</span>
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li style="cursor: pointer" @click="invite">
                  <span>
                    <img src="@/assets/add account.svg" />&nbsp;&nbsp; Invite
                    People
                  </span>
                </li>
                <li style="cursor: pointer">
                  <a :href="FEEDBACK">
                    <img src="@/assets/Like.svg" />&nbsp;&nbsp;
                    <span> Send a Feedback </span>
                  </a>
                </li>
                <li style="cursor: pointer" @click="copy_invite_link">
                  <span>
                    <img src="@/assets/copy-btn.svg" />&nbsp;&nbsp;
                    <span>Copy Referral Link</span>
                  </span>
                  <input type="hidden" id="referral_link" :value="$store.getters.REFERRAL_LINK" />
                </li>
                <li style="cursor: pointer">
                  <a :href="FAQ">
                    <img src="@/assets/Help.svg" />&nbsp;&nbsp;
                    <span> Help </span>
                  </a>
                </li>
                <li @click="startTour" style="cursor: pointer">
                  <span>
                    <img src="@/assets/puzzle.svg" />&nbsp;&nbsp;
                    <span> Take a Tour </span>
                  </span>
                </li>
                <li style="cursor: pointer" v-if="$store.getters.CURRENT_PLAN == 1">
                  <router-link to="/payments-billing" class="upgrade-btn">
                    Upgrade to Pro
                  </router-link>
                </li>
                <li class="logout" @click="logout">
                  <span>
                    <img src="@/assets/Signout.svg" />&nbsp;&nbsp;
                    <span>Logout</span>
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="menu-slide-bg" :class="{ show: mobile_menu }" @click.self="show_mobile_menu">
      <template v-if="env === 'local'">
        <ul class="url">
          <li>
            <a href="/"><img src="@/assets/logo-small-blue.png" /></a>
          </li>

          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':9009'">Dashboard</a>
          </li>
          <li class="active">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.29 10.79L11 14.09L9.71 12.79C9.5217 12.6017 9.2663 12.4959 9 12.4959C8.7337 12.4959 8.4783 12.6017 8.29 12.79C8.1017 12.9783 7.99591 13.2337 7.99591 13.5C7.99591 13.7663 8.1017 14.0217 8.29 14.21L10.29 16.21C10.383 16.3037 10.4936 16.3781 10.6154 16.4289C10.7373 16.4797 10.868 16.5058 11 16.5058C11.132 16.5058 11.2627 16.4797 11.3846 16.4289C11.5064 16.3781 11.617 16.3037 11.71 16.21L15.71 12.21C15.8983 12.0217 16.0041 11.7663 16.0041 11.5C16.0041 11.2337 15.8983 10.9783 15.71 10.79C15.5217 10.6017 15.2663 10.4959 15 10.4959C14.7337 10.4959 14.4783 10.6017 14.29 10.79ZM19 5.50002H12.72L12.4 4.50002C12.1926 3.91325 11.8077 3.40553 11.2989 3.04718C10.7901 2.68884 10.1824 2.49762 9.56 2.50002H5C4.20435 2.50002 3.44129 2.81609 2.87868 3.3787C2.31607 3.94131 2 4.70437 2 5.50002V18.5C2 19.2957 2.31607 20.0587 2.87868 20.6213C3.44129 21.184 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.184 21.1213 20.6213C21.6839 20.0587 22 19.2957 22 18.5V8.50002C22 7.70437 21.6839 6.94131 21.1213 6.3787C20.5587 5.81609 19.7956 5.50002 19 5.50002ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3947 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3947 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V5.50002C4 5.23481 4.10536 4.98045 4.29289 4.79292C4.48043 4.60538 4.73478 4.50002 5 4.50002H9.56C9.76964 4.49948 9.97416 4.56484 10.1446 4.68686C10.3151 4.80889 10.4429 4.9814 10.51 5.18002L11.05 6.82002C11.1171 7.01864 11.2449 7.19116 11.4154 7.31318C11.5858 7.4352 11.7904 7.50056 12 7.50002H19C19.2652 7.50002 19.5196 7.60538 19.7071 7.79292C19.8946 7.98045 20 8.23481 20 8.50002V18.5Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':7080'">Drive</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 6.5H16V5.5C16 4.70435 15.6839 3.94129 15.1213 3.37868C14.5587 2.81607 13.7956 2.5 13 2.5H11C10.2044 2.5 9.44129 2.81607 8.87868 3.37868C8.31607 3.94129 8 4.70435 8 5.5V6.5H5C4.20435 6.5 3.44129 6.81607 2.87868 7.37868C2.31607 7.94129 2 8.70435 2 9.5V18.5C2 19.2956 2.31607 20.0587 2.87868 20.6213C3.44129 21.1839 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.1839 21.1213 20.6213C21.6839 20.0587 22 19.2956 22 18.5V9.5C22 8.70435 21.6839 7.94129 21.1213 7.37868C20.5587 6.81607 19.7956 6.5 19 6.5ZM10 5.5C10 5.23478 10.1054 4.98043 10.2929 4.79289C10.4804 4.60536 10.7348 4.5 11 4.5H13C13.2652 4.5 13.5196 4.60536 13.7071 4.79289C13.8946 4.98043 14 5.23478 14 5.5V6.5H10V5.5ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3946 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3946 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V13C6.54626 14.0101 9.26069 14.5293 12 14.53C14.7392 14.5283 17.4535 14.0092 20 13V18.5ZM20 10.81C17.4784 11.9178 14.7542 12.4898 12 12.4898C9.24579 12.4898 6.5216 11.9178 4 10.81V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V10.81Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':3002/collaboration'">Projects</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 22H19C20.103 22 21 21.103 21 20V5C21 3.897 20.103 3 19 3H17C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3H5C3.897 3 3 3.897 3 5V20C3 21.103 3.897 22 5 22ZM5 5H7V7H17V5H19V20H5V5Z"
                fill="currentColor"></path>
              <path d="M11 13.586L9.20697 11.793L7.79297 13.207L11 16.414L16.207 11.207L14.793 9.79297L11 13.586Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':3002/tasks'"> Task </a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 22H19C20.103 22 21 21.103 21 20V5C21 3.897 20.103 3 19 3H17C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3H5C3.897 3 3 3.897 3 5V20C3 21.103 3.897 22 5 22ZM5 5H7V7H17V5H19V20H5V5Z"
                fill="currentColor"></path>
              <path d="M11 13.586L9.20697 11.793L7.79297 13.207L11 16.414L16.207 11.207L14.793 9.79297L11 13.586Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':3002/crm'">CRM</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V12H20V19ZM20 10H4V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V10Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':9009/calendar/month'">Schedules</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.53 7.15C21.378 7.06223 21.2055 7.01603 21.03 7.01603C20.8545 7.01603 20.682 7.06223 20.53 7.15L17 8.89C16.9715 8.11357 16.6429 7.37847 16.0834 6.83944C15.5238 6.3004 14.777 5.99948 14 6H5C4.20435 6 3.44129 6.31607 2.87868 6.87868C2.31607 7.44129 2 8.20435 2 9V15C2 15.7957 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H14C14.777 18.0005 15.5238 17.6996 16.0834 17.1606C16.6429 16.6215 16.9715 15.8864 17 15.11L20.56 16.89C20.6963 16.9599 20.8468 16.9975 21 17C21.1872 17.0006 21.3709 16.9486 21.53 16.85C21.6741 16.7599 21.7929 16.6346 21.8751 16.4859C21.9574 16.3372 22.0003 16.1699 22 16V8C22.0003 7.83006 21.9574 7.66283 21.8751 7.51411C21.7929 7.36538 21.6741 7.24007 21.53 7.15ZM15 15C15 15.2652 14.8946 15.5196 14.7071 15.7071C14.5196 15.8946 14.2652 16 14 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V9C4 8.73478 4.10536 8.48043 4.29289 8.29289C4.48043 8.10536 4.73478 8 5 8H14C14.2652 8 14.5196 8.10536 14.7071 8.29289C14.8946 8.48043 15 8.73478 15 9V15ZM20 14.38L17 12.88V11.12L20 9.62V14.38Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':9009/m/meetings'">Meeting</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 8H18V5C18 4.20435 17.6839 3.44129 17.1213 2.87868C16.5587 2.31607 15.7956 2 15 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V17C2.00099 17.1974 2.06039 17.3901 2.17072 17.5539C2.28105 17.7176 2.43738 17.845 2.62 17.92C2.73868 17.976 2.86882 18.0034 3 18C3.13161 18.0008 3.26207 17.9755 3.38391 17.9258C3.50574 17.876 3.61656 17.8027 3.71 17.71L6.52 14.89H8V16.33C8 17.1256 8.31607 17.8887 8.87868 18.4513C9.44129 19.0139 10.2044 19.33 11 19.33H17.92L20.29 21.71C20.3834 21.8027 20.4943 21.876 20.6161 21.9258C20.7379 21.9755 20.8684 22.0008 21 22C21.1312 22.0034 21.2613 21.976 21.38 21.92C21.5626 21.845 21.7189 21.7176 21.8293 21.5539C21.9396 21.3901 21.999 21.1974 22 21V11C22 10.2044 21.6839 9.44129 21.1213 8.87868C20.5587 8.31607 19.7956 8 19 8ZM8 11V12.89H6.11C5.97839 12.8892 5.84793 12.9145 5.72609 12.9642C5.60426 13.014 5.49344 13.0873 5.4 13.18L4 14.59V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H15C15.2652 4 15.5196 4.10536 15.7071 4.29289C15.8946 4.48043 16 4.73478 16 5V8H11C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11ZM20 18.59L19 17.59C18.9074 17.4955 18.7969 17.4203 18.6751 17.3688C18.5532 17.3173 18.4223 17.2906 18.29 17.29H11C10.7348 17.29 10.4804 17.1846 10.2929 16.9971C10.1054 16.8096 10 16.5552 10 16.29V11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H19C19.2652 10 19.5196 10.1054 19.7071 10.2929C19.8946 10.4804 20 10.7348 20 11V18.59Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':9009/m/chats'">Conversations</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z"
                fill="currentColor"></path>
            </svg>
            <a :href="protocol + '//' + host + ':3002/teams'"> Teams </a>
          </li>
          <template v-if="$store.getters.ACCT_TYPE == 2">
            <li>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.41 8.64013C21.41 8.64013 21.41 8.64013 21.41 8.59013C20.7054 6.66635 19.4269 5.00541 17.7475 3.83199C16.0681 2.65857 14.0688 2.0293 12.02 2.0293C9.97126 2.0293 7.97195 2.65857 6.29252 3.83199C4.6131 5.00541 3.33461 6.66635 2.63001 8.59013C2.63001 8.59013 2.63001 8.59013 2.63001 8.64013C1.84314 10.811 1.84314 13.1892 2.63001 15.3601C2.63001 15.3601 2.63001 15.3601 2.63001 15.4101C3.33461 17.3339 4.6131 18.9948 6.29252 20.1683C7.97195 21.3417 9.97126 21.971 12.02 21.971C14.0688 21.971 16.0681 21.3417 17.7475 20.1683C19.4269 18.9948 20.7054 17.3339 21.41 15.4101C21.41 15.4101 21.41 15.4101 21.41 15.3601C22.1969 13.1892 22.1969 10.811 21.41 8.64013ZM4.26001 14.0001C3.91324 12.6893 3.91324 11.3109 4.26001 10.0001H6.12001C5.96004 11.3287 5.96004 12.6716 6.12001 14.0001H4.26001ZM5.08001 16.0001H6.48001C6.71473 16.892 7.05022 17.7542 7.48001 18.5701C6.49931 17.9021 5.67951 17.0242 5.08001 16.0001ZM6.48001 8.00013H5.08001C5.67088 6.97921 6.4802 6.10159 7.45001 5.43013C7.03057 6.24737 6.70515 7.10954 6.48001 8.00013ZM11 19.7001C9.77178 18.7988 8.90916 17.4854 8.57001 16.0001H11V19.7001ZM11 14.0001H8.14001C7.9534 12.6733 7.9534 11.3269 8.14001 10.0001H11V14.0001ZM11 8.00013H8.57001C8.90916 6.51489 9.77178 5.20144 11 4.30013V8.00013ZM18.92 8.00013H17.52C17.2853 7.10828 16.9498 6.24606 16.52 5.43013C17.5007 6.0982 18.3205 6.97607 18.92 8.00013ZM13 4.30013C14.2282 5.20144 15.0909 6.51489 15.43 8.00013H13V4.30013ZM13 19.7001V16.0001H15.43C15.0909 17.4854 14.2282 18.7988 13 19.7001ZM15.86 14.0001H13V10.0001H15.86C16.0466 11.3269 16.0466 12.6733 15.86 14.0001ZM16.55 18.5701C16.9798 17.7542 17.3153 16.892 17.55 16.0001H18.95C18.3505 17.0242 17.5307 17.9021 16.55 18.5701ZM19.74 14.0001H17.88C17.9613 13.3366 18.0014 12.6686 18 12.0001C18.0011 11.3316 17.961 10.6637 17.88 10.0001H19.74C20.0868 11.3109 20.0868 12.6893 19.74 14.0001Z"
                  fill="currentColor"></path>
              </svg>
              <a :href="protocol + '//' + host + ':9009/explore'">Feed</a>
            </li>
          </template>
          <template v-else>
            <li>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.41 8.64013C21.41 8.64013 21.41 8.64013 21.41 8.59013C20.7054 6.66635 19.4269 5.00541 17.7475 3.83199C16.0681 2.65857 14.0688 2.0293 12.02 2.0293C9.97126 2.0293 7.97195 2.65857 6.29252 3.83199C4.6131 5.00541 3.33461 6.66635 2.63001 8.59013C2.63001 8.59013 2.63001 8.59013 2.63001 8.64013C1.84314 10.811 1.84314 13.1892 2.63001 15.3601C2.63001 15.3601 2.63001 15.3601 2.63001 15.4101C3.33461 17.3339 4.6131 18.9948 6.29252 20.1683C7.97195 21.3417 9.97126 21.971 12.02 21.971C14.0688 21.971 16.0681 21.3417 17.7475 20.1683C19.4269 18.9948 20.7054 17.3339 21.41 15.4101C21.41 15.4101 21.41 15.4101 21.41 15.3601C22.1969 13.1892 22.1969 10.811 21.41 8.64013ZM4.26001 14.0001C3.91324 12.6893 3.91324 11.3109 4.26001 10.0001H6.12001C5.96004 11.3287 5.96004 12.6716 6.12001 14.0001H4.26001ZM5.08001 16.0001H6.48001C6.71473 16.892 7.05022 17.7542 7.48001 18.5701C6.49931 17.9021 5.67951 17.0242 5.08001 16.0001ZM6.48001 8.00013H5.08001C5.67088 6.97921 6.4802 6.10159 7.45001 5.43013C7.03057 6.24737 6.70515 7.10954 6.48001 8.00013ZM11 19.7001C9.77178 18.7988 8.90916 17.4854 8.57001 16.0001H11V19.7001ZM11 14.0001H8.14001C7.9534 12.6733 7.9534 11.3269 8.14001 10.0001H11V14.0001ZM11 8.00013H8.57001C8.90916 6.51489 9.77178 5.20144 11 4.30013V8.00013ZM18.92 8.00013H17.52C17.2853 7.10828 16.9498 6.24606 16.52 5.43013C17.5007 6.0982 18.3205 6.97607 18.92 8.00013ZM13 4.30013C14.2282 5.20144 15.0909 6.51489 15.43 8.00013H13V4.30013ZM13 19.7001V16.0001H15.43C15.0909 17.4854 14.2282 18.7988 13 19.7001ZM15.86 14.0001H13V10.0001H15.86C16.0466 11.3269 16.0466 12.6733 15.86 14.0001ZM16.55 18.5701C16.9798 17.7542 17.3153 16.892 17.55 16.0001H18.95C18.3505 17.0242 17.5307 17.9021 16.55 18.5701ZM19.74 14.0001H17.88C17.9613 13.3366 18.0014 12.6686 18 12.0001C18.0011 11.3316 17.961 10.6637 17.88 10.0001H19.74C20.0868 11.3109 20.0868 12.6893 19.74 14.0001Z"
                  fill="currentColor"></path>
              </svg>
              <a :href="protocol + '//' + host + ':9009/explore'">Community</a>
            </li>
          </template>
        </ul>
      </template>
      <template v-if="env === 'prod'">
        <ul class="url">
          <li>
            <a href="/"><img src="@/assets/logo-small-blue.png" /></a>
          </li>

          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M10 13H3C2.73478 13 2.48043 13.1054 2.29289 13.2929C2.10536 13.4804 2 13.7348 2 14V21C2 21.2652 2.10536 21.5196 2.29289 21.7071C2.48043 21.8946 2.73478 22 3 22H10C10.2652 22 10.5196 21.8946 10.7071 21.7071C10.8946 21.5196 11 21.2652 11 21V14C11 13.7348 10.8946 13.4804 10.7071 13.2929C10.5196 13.1054 10.2652 13 10 13ZM9 20H4V15H9V20ZM21 2H14C13.7348 2 13.4804 2.10536 13.2929 2.29289C13.1054 2.48043 13 2.73478 13 3V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H21C21.2652 11 21.5196 10.8946 21.7071 10.7071C21.8946 10.5196 22 10.2652 22 10V3C22 2.73478 21.8946 2.48043 21.7071 2.29289C21.5196 2.10536 21.2652 2 21 2ZM20 9H15V4H20V9ZM21 13H14C13.7348 13 13.4804 13.1054 13.2929 13.2929C13.1054 13.4804 13 13.7348 13 14V21C13 21.2652 13.1054 21.5196 13.2929 21.7071C13.4804 21.8946 13.7348 22 14 22H21C21.2652 22 21.5196 21.8946 21.7071 21.7071C21.8946 21.5196 22 21.2652 22 21V14C22 13.7348 21.8946 13.4804 21.7071 13.2929C21.5196 13.1054 21.2652 13 21 13ZM20 20H15V15H20V20ZM10 2H3C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V10C2 10.2652 2.10536 10.5196 2.29289 10.7071C2.48043 10.8946 2.73478 11 3 11H10C10.2652 11 10.5196 10.8946 10.7071 10.7071C10.8946 10.5196 11 10.2652 11 10V3C11 2.73478 10.8946 2.48043 10.7071 2.29289C10.5196 2.10536 10.2652 2 10 2ZM9 9H4V4H9V9Z"
                fill="currentColor"></path>
            </svg>
            <a :href="DASHBOARD">Dashboard</a>
          </li>
          <li class="active">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.29 10.79L11 14.09L9.71 12.79C9.5217 12.6017 9.2663 12.4959 9 12.4959C8.7337 12.4959 8.4783 12.6017 8.29 12.79C8.1017 12.9783 7.99591 13.2337 7.99591 13.5C7.99591 13.7663 8.1017 14.0217 8.29 14.21L10.29 16.21C10.383 16.3037 10.4936 16.3781 10.6154 16.4289C10.7373 16.4797 10.868 16.5058 11 16.5058C11.132 16.5058 11.2627 16.4797 11.3846 16.4289C11.5064 16.3781 11.617 16.3037 11.71 16.21L15.71 12.21C15.8983 12.0217 16.0041 11.7663 16.0041 11.5C16.0041 11.2337 15.8983 10.9783 15.71 10.79C15.5217 10.6017 15.2663 10.4959 15 10.4959C14.7337 10.4959 14.4783 10.6017 14.29 10.79ZM19 5.50002H12.72L12.4 4.50002C12.1926 3.91325 11.8077 3.40553 11.2989 3.04718C10.7901 2.68884 10.1824 2.49762 9.56 2.50002H5C4.20435 2.50002 3.44129 2.81609 2.87868 3.3787C2.31607 3.94131 2 4.70437 2 5.50002V18.5C2 19.2957 2.31607 20.0587 2.87868 20.6213C3.44129 21.184 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.184 21.1213 20.6213C21.6839 20.0587 22 19.2957 22 18.5V8.50002C22 7.70437 21.6839 6.94131 21.1213 6.3787C20.5587 5.81609 19.7956 5.50002 19 5.50002ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3947 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3947 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V5.50002C4 5.23481 4.10536 4.98045 4.29289 4.79292C4.48043 4.60538 4.73478 4.50002 5 4.50002H9.56C9.76964 4.49948 9.97416 4.56484 10.1446 4.68686C10.3151 4.80889 10.4429 4.9814 10.51 5.18002L11.05 6.82002C11.1171 7.01864 11.2449 7.19116 11.4154 7.31318C11.5858 7.4352 11.7904 7.50056 12 7.50002H19C19.2652 7.50002 19.5196 7.60538 19.7071 7.79292C19.8946 7.98045 20 8.23481 20 8.50002V18.5Z"
                fill="currentColor"></path>
            </svg>
            <a :href="DRIVE">Drive</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 6.5H16V5.5C16 4.70435 15.6839 3.94129 15.1213 3.37868C14.5587 2.81607 13.7956 2.5 13 2.5H11C10.2044 2.5 9.44129 2.81607 8.87868 3.37868C8.31607 3.94129 8 4.70435 8 5.5V6.5H5C4.20435 6.5 3.44129 6.81607 2.87868 7.37868C2.31607 7.94129 2 8.70435 2 9.5V18.5C2 19.2956 2.31607 20.0587 2.87868 20.6213C3.44129 21.1839 4.20435 21.5 5 21.5H19C19.7956 21.5 20.5587 21.1839 21.1213 20.6213C21.6839 20.0587 22 19.2956 22 18.5V9.5C22 8.70435 21.6839 7.94129 21.1213 7.37868C20.5587 6.81607 19.7956 6.5 19 6.5ZM10 5.5C10 5.23478 10.1054 4.98043 10.2929 4.79289C10.4804 4.60536 10.7348 4.5 11 4.5H13C13.2652 4.5 13.5196 4.60536 13.7071 4.79289C13.8946 4.98043 14 5.23478 14 5.5V6.5H10V5.5ZM20 18.5C20 18.7652 19.8946 19.0196 19.7071 19.2071C19.5196 19.3946 19.2652 19.5 19 19.5H5C4.73478 19.5 4.48043 19.3946 4.29289 19.2071C4.10536 19.0196 4 18.7652 4 18.5V13C6.54626 14.0101 9.26069 14.5293 12 14.53C14.7392 14.5283 17.4535 14.0092 20 13V18.5ZM20 10.81C17.4784 11.9178 14.7542 12.4898 12 12.4898C9.24579 12.4898 6.5216 11.9178 4 10.81V9.5C4 9.23478 4.10536 8.98043 4.29289 8.79289C4.48043 8.60536 4.73478 8.5 5 8.5H19C19.2652 8.5 19.5196 8.60536 19.7071 8.79289C19.8946 8.98043 20 9.23478 20 9.5V10.81Z"
                fill="currentColor"></path>
            </svg>
            <a :href="PROJECTS">Projects</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 22H19C20.103 22 21 21.103 21 20V5C21 3.897 20.103 3 19 3H17C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3H5C3.897 3 3 3.897 3 5V20C3 21.103 3.897 22 5 22ZM5 5H7V7H17V5H19V20H5V5Z"
                fill="currentColor"></path>
              <path d="M11 13.586L9.20697 11.793L7.79297 13.207L11 16.414L16.207 11.207L14.793 9.79297L11 13.586Z"
                fill="currentColor"></path>
            </svg>
            <a :href="TASKS">Task</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M5 22H19C20.103 22 21 21.103 21 20V5C21 3.897 20.103 3 19 3H17C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2H8C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3H5C3.897 3 3 3.897 3 5V20C3 21.103 3.897 22 5 22ZM5 5H7V7H17V5H19V20H5V5Z"
                fill="currentColor"></path>
              <path d="M11 13.586L9.20697 11.793L7.79297 13.207L11 16.414L16.207 11.207L14.793 9.79297L11 13.586Z"
                fill="currentColor"></path>
            </svg>
            <a :href="CRM">CRM</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 4H17V3C17 2.73478 16.8946 2.48043 16.7071 2.29289C16.5196 2.10536 16.2652 2 16 2C15.7348 2 15.4804 2.10536 15.2929 2.29289C15.1054 2.48043 15 2.73478 15 3V4H9V3C9 2.73478 8.89464 2.48043 8.70711 2.29289C8.51957 2.10536 8.26522 2 8 2C7.73478 2 7.48043 2.10536 7.29289 2.29289C7.10536 2.48043 7 2.73478 7 3V4H5C4.20435 4 3.44129 4.31607 2.87868 4.87868C2.31607 5.44129 2 6.20435 2 7V19C2 19.7956 2.31607 20.5587 2.87868 21.1213C3.44129 21.6839 4.20435 22 5 22H19C19.7956 22 20.5587 21.6839 21.1213 21.1213C21.6839 20.5587 22 19.7956 22 19V7C22 6.20435 21.6839 5.44129 21.1213 4.87868C20.5587 4.31607 19.7956 4 19 4ZM20 19C20 19.2652 19.8946 19.5196 19.7071 19.7071C19.5196 19.8946 19.2652 20 19 20H5C4.73478 20 4.48043 19.8946 4.29289 19.7071C4.10536 19.5196 4 19.2652 4 19V12H20V19ZM20 10H4V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H7V7C7 7.26522 7.10536 7.51957 7.29289 7.70711C7.48043 7.89464 7.73478 8 8 8C8.26522 8 8.51957 7.89464 8.70711 7.70711C8.89464 7.51957 9 7.26522 9 7V6H15V7C15 7.26522 15.1054 7.51957 15.2929 7.70711C15.4804 7.89464 15.7348 8 16 8C16.2652 8 16.5196 7.89464 16.7071 7.70711C16.8946 7.51957 17 7.26522 17 7V6H19C19.2652 6 19.5196 6.10536 19.7071 6.29289C19.8946 6.48043 20 6.73478 20 7V10Z"
                fill="currentColor"></path>
            </svg>
            <a :href="CALENDAR">Schedules</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M21.53 7.15C21.378 7.06223 21.2055 7.01603 21.03 7.01603C20.8545 7.01603 20.682 7.06223 20.53 7.15L17 8.89C16.9715 8.11357 16.6429 7.37847 16.0834 6.83944C15.5238 6.3004 14.777 5.99948 14 6H5C4.20435 6 3.44129 6.31607 2.87868 6.87868C2.31607 7.44129 2 8.20435 2 9V15C2 15.7957 2.31607 16.5587 2.87868 17.1213C3.44129 17.6839 4.20435 18 5 18H14C14.777 18.0005 15.5238 17.6996 16.0834 17.1606C16.6429 16.6215 16.9715 15.8864 17 15.11L20.56 16.89C20.6963 16.9599 20.8468 16.9975 21 17C21.1872 17.0006 21.3709 16.9486 21.53 16.85C21.6741 16.7599 21.7929 16.6346 21.8751 16.4859C21.9574 16.3372 22.0003 16.1699 22 16V8C22.0003 7.83006 21.9574 7.66283 21.8751 7.51411C21.7929 7.36538 21.6741 7.24007 21.53 7.15ZM15 15C15 15.2652 14.8946 15.5196 14.7071 15.7071C14.5196 15.8946 14.2652 16 14 16H5C4.73478 16 4.48043 15.8946 4.29289 15.7071C4.10536 15.5196 4 15.2652 4 15V9C4 8.73478 4.10536 8.48043 4.29289 8.29289C4.48043 8.10536 4.73478 8 5 8H14C14.2652 8 14.5196 8.10536 14.7071 8.29289C14.8946 8.48043 15 8.73478 15 9V15ZM20 14.38L17 12.88V11.12L20 9.62V14.38Z"
                fill="currentColor"></path>
            </svg>
            <a :href="MEETING">Meeting</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 8H18V5C18 4.20435 17.6839 3.44129 17.1213 2.87868C16.5587 2.31607 15.7956 2 15 2H5C4.20435 2 3.44129 2.31607 2.87868 2.87868C2.31607 3.44129 2 4.20435 2 5V17C2.00099 17.1974 2.06039 17.3901 2.17072 17.5539C2.28105 17.7176 2.43738 17.845 2.62 17.92C2.73868 17.976 2.86882 18.0034 3 18C3.13161 18.0008 3.26207 17.9755 3.38391 17.9258C3.50574 17.876 3.61656 17.8027 3.71 17.71L6.52 14.89H8V16.33C8 17.1256 8.31607 17.8887 8.87868 18.4513C9.44129 19.0139 10.2044 19.33 11 19.33H17.92L20.29 21.71C20.3834 21.8027 20.4943 21.876 20.6161 21.9258C20.7379 21.9755 20.8684 22.0008 21 22C21.1312 22.0034 21.2613 21.976 21.38 21.92C21.5626 21.845 21.7189 21.7176 21.8293 21.5539C21.9396 21.3901 21.999 21.1974 22 21V11C22 10.2044 21.6839 9.44129 21.1213 8.87868C20.5587 8.31607 19.7956 8 19 8ZM8 11V12.89H6.11C5.97839 12.8892 5.84793 12.9145 5.72609 12.9642C5.60426 13.014 5.49344 13.0873 5.4 13.18L4 14.59V5C4 4.73478 4.10536 4.48043 4.29289 4.29289C4.48043 4.10536 4.73478 4 5 4H15C15.2652 4 15.5196 4.10536 15.7071 4.29289C15.8946 4.48043 16 4.73478 16 5V8H11C10.2044 8 9.44129 8.31607 8.87868 8.87868C8.31607 9.44129 8 10.2044 8 11ZM20 18.59L19 17.59C18.9074 17.4955 18.7969 17.4203 18.6751 17.3688C18.5532 17.3173 18.4223 17.2906 18.29 17.29H11C10.7348 17.29 10.4804 17.1846 10.2929 16.9971C10.1054 16.8096 10 16.5552 10 16.29V11C10 10.7348 10.1054 10.4804 10.2929 10.2929C10.4804 10.1054 10.7348 10 11 10H19C19.2652 10 19.5196 10.1054 19.7071 10.2929C19.8946 10.4804 20 10.7348 20 11V18.59Z"
                fill="currentColor"></path>
            </svg>
            <a :href="MESSAGE">Conversations</a>
          </li>
          <li>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z"
                fill="currentColor"></path>
            </svg>
            <a :href="TEAMS">Team</a>
          </li>
          <template v-if="$store.getters.ACCT_TYPE == 2">
            <li>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.41 8.64013C21.41 8.64013 21.41 8.64013 21.41 8.59013C20.7054 6.66635 19.4269 5.00541 17.7475 3.83199C16.0681 2.65857 14.0688 2.0293 12.02 2.0293C9.97126 2.0293 7.97195 2.65857 6.29252 3.83199C4.6131 5.00541 3.33461 6.66635 2.63001 8.59013C2.63001 8.59013 2.63001 8.59013 2.63001 8.64013C1.84314 10.811 1.84314 13.1892 2.63001 15.3601C2.63001 15.3601 2.63001 15.3601 2.63001 15.4101C3.33461 17.3339 4.6131 18.9948 6.29252 20.1683C7.97195 21.3417 9.97126 21.971 12.02 21.971C14.0688 21.971 16.0681 21.3417 17.7475 20.1683C19.4269 18.9948 20.7054 17.3339 21.41 15.4101C21.41 15.4101 21.41 15.4101 21.41 15.3601C22.1969 13.1892 22.1969 10.811 21.41 8.64013ZM4.26001 14.0001C3.91324 12.6893 3.91324 11.3109 4.26001 10.0001H6.12001C5.96004 11.3287 5.96004 12.6716 6.12001 14.0001H4.26001ZM5.08001 16.0001H6.48001C6.71473 16.892 7.05022 17.7542 7.48001 18.5701C6.49931 17.9021 5.67951 17.0242 5.08001 16.0001ZM6.48001 8.00013H5.08001C5.67088 6.97921 6.4802 6.10159 7.45001 5.43013C7.03057 6.24737 6.70515 7.10954 6.48001 8.00013ZM11 19.7001C9.77178 18.7988 8.90916 17.4854 8.57001 16.0001H11V19.7001ZM11 14.0001H8.14001C7.9534 12.6733 7.9534 11.3269 8.14001 10.0001H11V14.0001ZM11 8.00013H8.57001C8.90916 6.51489 9.77178 5.20144 11 4.30013V8.00013ZM18.92 8.00013H17.52C17.2853 7.10828 16.9498 6.24606 16.52 5.43013C17.5007 6.0982 18.3205 6.97607 18.92 8.00013ZM13 4.30013C14.2282 5.20144 15.0909 6.51489 15.43 8.00013H13V4.30013ZM13 19.7001V16.0001H15.43C15.0909 17.4854 14.2282 18.7988 13 19.7001ZM15.86 14.0001H13V10.0001H15.86C16.0466 11.3269 16.0466 12.6733 15.86 14.0001ZM16.55 18.5701C16.9798 17.7542 17.3153 16.892 17.55 16.0001H18.95C18.3505 17.0242 17.5307 17.9021 16.55 18.5701ZM19.74 14.0001H17.88C17.9613 13.3366 18.0014 12.6686 18 12.0001C18.0011 11.3316 17.961 10.6637 17.88 10.0001H19.74C20.0868 11.3109 20.0868 12.6893 19.74 14.0001Z"
                  fill="currentColor"></path>
              </svg>
              <a :href="EXPLORE">Feed</a>
            </li>
          </template>
          <template v-else>
            <li>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.41 8.64013C21.41 8.64013 21.41 8.64013 21.41 8.59013C20.7054 6.66635 19.4269 5.00541 17.7475 3.83199C16.0681 2.65857 14.0688 2.0293 12.02 2.0293C9.97126 2.0293 7.97195 2.65857 6.29252 3.83199C4.6131 5.00541 3.33461 6.66635 2.63001 8.59013C2.63001 8.59013 2.63001 8.59013 2.63001 8.64013C1.84314 10.811 1.84314 13.1892 2.63001 15.3601C2.63001 15.3601 2.63001 15.3601 2.63001 15.4101C3.33461 17.3339 4.6131 18.9948 6.29252 20.1683C7.97195 21.3417 9.97126 21.971 12.02 21.971C14.0688 21.971 16.0681 21.3417 17.7475 20.1683C19.4269 18.9948 20.7054 17.3339 21.41 15.4101C21.41 15.4101 21.41 15.4101 21.41 15.3601C22.1969 13.1892 22.1969 10.811 21.41 8.64013ZM4.26001 14.0001C3.91324 12.6893 3.91324 11.3109 4.26001 10.0001H6.12001C5.96004 11.3287 5.96004 12.6716 6.12001 14.0001H4.26001ZM5.08001 16.0001H6.48001C6.71473 16.892 7.05022 17.7542 7.48001 18.5701C6.49931 17.9021 5.67951 17.0242 5.08001 16.0001ZM6.48001 8.00013H5.08001C5.67088 6.97921 6.4802 6.10159 7.45001 5.43013C7.03057 6.24737 6.70515 7.10954 6.48001 8.00013ZM11 19.7001C9.77178 18.7988 8.90916 17.4854 8.57001 16.0001H11V19.7001ZM11 14.0001H8.14001C7.9534 12.6733 7.9534 11.3269 8.14001 10.0001H11V14.0001ZM11 8.00013H8.57001C8.90916 6.51489 9.77178 5.20144 11 4.30013V8.00013ZM18.92 8.00013H17.52C17.2853 7.10828 16.9498 6.24606 16.52 5.43013C17.5007 6.0982 18.3205 6.97607 18.92 8.00013ZM13 4.30013C14.2282 5.20144 15.0909 6.51489 15.43 8.00013H13V4.30013ZM13 19.7001V16.0001H15.43C15.0909 17.4854 14.2282 18.7988 13 19.7001ZM15.86 14.0001H13V10.0001H15.86C16.0466 11.3269 16.0466 12.6733 15.86 14.0001ZM16.55 18.5701C16.9798 17.7542 17.3153 16.892 17.55 16.0001H18.95C18.3505 17.0242 17.5307 17.9021 16.55 18.5701ZM19.74 14.0001H17.88C17.9613 13.3366 18.0014 12.6686 18 12.0001C18.0011 11.3316 17.961 10.6637 17.88 10.0001H19.74C20.0868 11.3109 20.0868 12.6893 19.74 14.0001Z"
                  fill="currentColor"></path>
              </svg>
              <a :href="EXPLORE">Community</a>
            </li>
          </template>
        </ul>
      </template>
    </div>
  </div>
</template>
<style scoped>
.erp-menu {
  padding-top: .9em !important;
  padding-left: 20px !important;
  padding-right: 20px !important;
  width: 30em !important;
  max-height: calc(100vh - 5rem) !important;
  height: auto !important;
}

.erp-menu h4 {
  margin-bottom: 10px;
  text-align: center;
}

.erp-menu ul {
  padding-left: 0;
}

.erp-menu ul li {
  display: unset !important;
  text-align: left !important;
}


.erp-menu ul li h5 {
  font-weight: bold !important;
}

.erp-menu div.menu-grid {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 15px;
}

.erp-menu li {
  list-style: none;
}

.erp-menu h5 {
  font-size: 15px;
  font-weight: bold !important;
  margin-bottom: 16px;
  margin-top: 0 !important;
}

.erp-menu div.menu-grid a {
  display: flex;
  flex-direction: column;
  text-align: center;
  font-size: 12px;
  height: 120px;
  border: 1px solid #eee;
  align-items: center;
  justify-content: center;
  padding: 20px 15px;
  border-radius: 5px;
  font-weight: bold !important;
}

.erp-menu div.menu-grid a span:first-child {
  margin-bottom: 10px;
}

.menu-slide-bg {
  width: 100%;
  height: 100%;
  background: rgba(14, 29, 47, 0.54);
  position: fixed;
  top: 0;
  z-index: 100000;
  left: -100%;
  box-shadow: rgb(209 219 228 / 22%) 10px 4px 13px;
}

.menu-slide-bg.show {
  left: 0;
}

.menu-slide-bg ul {
  width: 255px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  left: -100%;
  position: absolute;
  top: 0;
  transition: left 300ms ease-in;
}

.menu-slide-bg.show ul {
  left: 0;
}

.menu-slide-bg ul li {
  font-size: 18px !important;
  padding: 0 1.5rem;
  font-weight: 500;
  height: 3rem;
  font-weight: 600;
  font-size: 0.875rem !important;
  display: flex;
  align-items: center;
  color: rgb(93, 105, 111);
  line-height: 0;
}

.menu-slide-bg ul li:first-of-type {
  height: 4.25rem;
}

.menu-slide-bg ul li:first-of-type img {
  width: 7.3rem;
}

.menu-slide-bg ul li svg {
  color: rgb(167, 185, 203);
}

.menu-slide-bg ul li a {
  padding-left: 1.125rem !important;
  color: rgb(93, 105, 111);
}

.menu-slide-bg ul li a:hover {
  background-color: #fff;
  color: rgb(93, 105, 111);
}

.menu-slide-bg ul li:first-of-type a {
  padding: 0 !important;
}

.menu-slide-bg ul li.active {
  border-radius: 0px;
  background: rgb(242, 247, 252);
  color: rgb(16, 46, 81);
}

.menu-slide-bg ul li.active a {
  background-color: inherit !important;
  color: rgb(16, 46, 81) !important;
  margin: 0 !important;
}

.menu-slide-bg ul li.active svg {
  color: rgb(63, 150, 209);
}

.userdropdown .default-pic {
  width: 4rem !important;
  height: 4rem !important;
  margin-bottom: 0.875rem;
}

.download-btn {
  display: inline-flex !important;
  text-align: center;
  border: none !important;
  padding: 0 !important;
  padding-top: 0.8em !important;
  margin-bottom: 0.8em;
  white-space: nowrap;
}

.download-btn span span {
  font-weight: 500;
}

.pic-house {
  padding: 0 !important;
}

.download-btn>span {
  display: inline-flex !important;
  justify-content: center;
  align-items: center;
  border: 1px solid #3f96d1;
  color: #3f96d1;
  padding: 1em 1.6em;
  border-radius: 6px;
  font-size: 13px;
}

.name-of-user {
  font-size: 1rem;
  font-weight: 600;
  color: #111;
}

.email-of-user {
  color: #4b5458 !important;
  font-size: 1rem;
}

.update-user-profile {
  padding: 0.6em 0;
  color: #3f96d1 !important;
  font-size: 0.875rem;
  font-weight: 600;
}

.userdropdown {
  background: #fff;
  position: absolute;
  top: 42px;
  right: 10px;
  text-align: left;
  width: 17.5rem;
  z-index: 10;
  border-radius: 0.25rem;
  box-shadow: 0px 4px 18px rgba(145, 157, 160, 0.17);
  text-align: center;
  padding: 1rem 1rem 0rem 1rem;
  height: fit-content;
  max-height: calc(100vh - 4.5rem);
  overflow: auto;
}

.logout {
  border-top: 1px solid #a7b9cb;
  padding-top: 1em;
  margin: 1.2em 0;
  color: #d20505;
}

.logout span {
  color: #d20505;
  font-family: "inter";
}

.userdropdown li {
  justify-content: space-between;
  display: flex;
  padding: 0.85rem 0.5rem;
  font-size: 0.875rem;
  color: rgba(74, 85, 104, 1);
}

.userdropdown li a:hover {
  text-decoration: none;
}

.userdropdown li a span {
  color: #111;
  font-family: "inter";
  font-size: 0.875rem;
}

.userdropdown li span {
  color: #111;
  font-family: "inter";
}

/* .userdropdown li span:hover {
  text-decoration: none;
  color: #2a7bb1;
} */
.userdropdown li a {
  color: rgba(74, 85, 104, 1);
}

.settings {
  cursor: pointer;
}

.note,
.chat,
.bell {
  cursor: pointer;
}

.default-pic {
  background: #e2e8f0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #71809a;
  font-weight: 500;
  height: inherit;
  width: inherit;
}

.custom-tooltip-container {
  position: relative;
  display: inline-block;
}

.custom-tooltip-container .custom-tooltiptext {
  visibility: hidden;
  background-color: #596a73;
  color: #fff;
  text-align: center;
  border-radius: 3px;
  padding: 2px 5px;
  position: absolute;
  z-index: 1;
  top: 25px;
  opacity: 0;
  transition: opacity 0.5s, padding 0.3s;
  font-size: 12px;
}

.custom-tooltip-container:hover .custom-tooltiptext {
  visibility: visible;
  opacity: 1;
  padding: 5px 10px;
}
</style>
<script>
// import { directive as onClickaway } from "vue-clickaway";
import ClickOutside from "vue-click-outside";
import { mapMutations } from "vuex";
import cookies from "@/services/cookies";
import moment from "moment";
import { $bus } from "../utils";
import NotificationIcon from "@/components/Icons/NotificationIcon";
import ChatIcon from "@/components/Icons/ChatIcon.vue";
import NoteIcon from "@/components/Icons/NoteIcon.vue";
import InviteIcon from "@/components/Icons/InviteIcon.vue";
import MenuIcon from "@/components/Icons/MenuIcon.vue";
import roles from "../roles.json"
import MenuIcon2 from '@/components/Icons/Menu'
import InvexMoneyTick from '@/components/Icons/InvexMoneyTick'
// import Tooltip from "@/components/Tooltip";
export default {
  components: {
    NotificationIcon,
    NoteIcon,
    ChatIcon,
    InviteIcon,
    MenuIcon,
    MenuIcon2,
    InvexMoneyTick
  },
  props: {
    data: Object,
  },
  data() {
    return {
      roles,
      settings_dropdown: false,
      userdropdown: null,
      sub_dropdown: false,
      sub_dropdown2: false,
      mobile_menu: false,
      show_min: false,
      env: process.env.NODE_ENV === "development" ? "local" : "prod",
      host: location.hostname,
      protocol: location.protocol,
      TASKS: process.env.VUE_APP_TASKS,
      CRM: process.env.VUE_APP_CRM,
      TEAMS: process.env.VUE_APP_TEAMS,
      MESSAGE: process.env.VUE_APP_MESSAGE,
      MEETING: process.env.VUE_APP_MEETING,
      CALENDAR: process.env.VUE_APP_CALENDAR,
      PROJECTS: process.env.VUE_APP_PROJECTS,
      DRIVE: process.env.VUE_APP_DRIVE,
      DASHBOARD: process.env.VUE_APP_DASHBOARD,
      EXPLORE: process.env.VUE_APP_EXPLORE,
      FAQ: process.env.VUE_APP_FAQ,
      FEEDBACK: process.env.VUE_APP_FEEDBACK,
      invexdropdown: false,
      invex_api_url: '',
      invex_domain: '',
      invextoken: cookies.getCookie('invextoken'),
      page:
        localStorage.getItem("page") == null ||
          localStorage.getItem("page") == undefined
          ? ""
          : localStorage.getItem("page"),
      page_url:
        localStorage.getItem("page_url") == null ||
          localStorage.getItem("page_url") == undefined
          ? ""
          : localStorage.getItem("page_url"),
    };
  },
  methods: {
    ...mapMutations([
      "SET_SORT_TYPE",
      "SET_SORT_ORDER",
      "SET_VIEW_TYPE",
      "SORT_DIRECTORY_CHILDREN",
      "TOGGLE_CHAT",
      "UPDATE_SLIDEIN",
      "UPDATE_SLIDEOUT",
      "UPDATE_BODY_MENU",
      "UPDATE_MENU",
      "SET_DIRECTORY_CHILDREN",
      "SET_STORED_DIRECTORY_CHILDREN",
      "SORT_DIRECTORY_CHILDREN",
      "TOGGLE_EMBED",
      "SET_TOTAL_CHAT",
      "SET_TOTAL_NOTIFICATION",
    ]),
    showinvexdropdown() {
      this.invexdropdown = !this.invexdropdown
    },
    startTour() {
      $bus.$emit("start-tour");
    },
    show_mobile_menu(evt) {
      this.mobile_menu = !this.mobile_menu;
    },
    show_mobile_menu2(evt) {
      if (evt.target.className == "menu-slide-bg") {
        this.mobile_menu = !this.mobile_menu;
      }
    },
    show_chat() {
      this.TOGGLE_EMBED("chat");
    },
    show_note() {
      this.TOGGLE_EMBED("note");
    },
    show_notification() {
      this.TOGGLE_EMBED("notification");
    },
    copy_invite_link() {
      let link = document.querySelector("#referral_link").value;
      let a = document.createElement("input");

      a.setAttribute("value", link);
      a.setAttribute("id", "referallink");
      a.click();
      a.style.position = "absolute";
      a.style.left = "-9999px";
      document.body.appendChild(a);
      let l = document.getElementById("referallink");
      l.select();
      document.execCommand("copy");
      document.body.removeChild(a);

      let that = this;

      that.$toast.open({
        message:
          '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M13,9H11V7H13M13,17H11V11H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></svg> Referral link copied to clipboard',
        type: "default",
        position: "bottom-right",
      });
    },
    invite() {
      this.userdropdown = false;
      this.$parent.invite();
    },
    getName(name) {
      return name[0];
    },
    download() {
      let a = document.createElement("a");
      a.setAttribute("download", true);
      let href = "https://fexspace.com/downloads/Fexspace-client-Setup.exe";
      a.setAttribute("href", href);
      a.hidden = true;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },
    drop_min() {
      this.show_min = !this.show_min;
    },
    user_dropdown() {
      this.userdropdown = !this.userdropdown;
    },
    show_subdown() {
      this.sub_dropdown = !this.sub_dropdown;
    },
    show_subdown2() {
      this.sub_dropdown2 = !this.sub_dropdown2;
    },
    format_date(date) {
      return moment(date).format("DD MMMM, YYYY");
    },
    logout() {
      this.$parent.logout();
    },
    slideout() {
      this.UPDATE_SLIDEIN(true);
      this.UPDATE_SLIDEOUT(false);
      this.UPDATE_MENU(false);
      this.UPDATE_BODY_MENU(true);
    },
    show_settings_dropdown() {
      if (this.settings_dropdown) {
        this.settings_dropdown = false;
      } else {
        this.settings_dropdown = true;
      }
    },
    hide() {
      this.settings_dropdown = false;
      // this.userdropdown = false
      // this.sub_dropdown = false
      // this.sub_dropdown2 = true
    },
    hideDropDown() {
      this.userdropdown = false;
    },
    close_drop(e) {
      if (
        e.target.nodeName === "LI" ||
        e.target.nodeName === "I" ||
        e.target.nodeName === "IMG" ||
        e.target.nodeName === "svg" ||
        e.target.nodeName === "SPAN"
      ) {
        this.create_dropdown = false;
        this.sort_order = false;
        this.view_options = false;
      }
    },
    clickOut(e) {
      if (this.userdropdown) {
        // this.userdropdown = false;
      }
    },
    hideInvexDropDownMenu() {
      this.invexdropdown = false
    },
    hideMenu() {
      this.userdropdown = false
    }
  },
  directives: {
    ClickOutside
  },
  mounted() {
    console.log(cookies.getCookie('invextoken'))
  }
};
</script>
